import React, { useState, useEffect, useRef } from 'react';
import { Chart, registerables } from 'chart.js';
import { ChevronDown, X, File as FileIcon, ShieldCheck, Briefcase, Check, PlusCircle, Plus } from 'lucide-react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleFetchRequest } from '../ApiHelper/ApiHelper';
import { apiUrl } from '../ApiHelper/ApiUrl';
import PageLoader from '../Loder/PageLoader';
import Sidebar from '../components/sidebar';
import Header from '../components/header';
import { useDispatch, useSelector } from 'react-redux';
import { createProject, getProjects, switchProject } from '../redux/features/project/projectSlice';
import { mockControlsInitial, mockGeneratedReports, mockOrgs, mockUsers } from '../dummy/dummy';


Chart.register(...registerables);



const View = ({ children }) => {

  const orgId = process.env.REACT_APP_ORG_ID
  const [selectedOrg, setSelectedOrg] = useState(mockOrgs[0]);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isNewProjectModalOpen, setIsNewProjectModalOpen] = useState(false);
  const [mockControls, setMockControls] = useState(mockControlsInitial);
  const [currentUser, setCurrentUser] = useState(mockUsers[1]);
  const [pageIsLoading, setPageIsLoading] = useState(false);
  const [evidenceData, setEvidenceData] = useState({
    'custom_3': {
      status: 'submitted',
      narrative: 'Evidence for this control was submitted for review by Cynthia Patel.',
      files: [{ name: 'Initial_Review_Package.pdf', type: 'pdf', url: '#' }]
    },
    'custom_2': { status: 'draft', narrative: 'Initial evidence for failed control.', files: [] }
  });
  const [remarksData, setRemarksData] = useState({});
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewingFile, setPreviewingFile] = useState(null);
  const [generatedReports, setGeneratedReports] = useState(mockGeneratedReports);

  const [organizations, setOrganizations] = useState(mockOrgs);
  const [isNewOrgModalOpen, setIsNewOrgModalOpen] = useState(false);
  const [activeNav, setActiveNav] = useState('dashboard');

  const [view, setView] = useState({ type: 'dashboard', data: null });
  const [evidenceDetails, setEvidenceDetails] = useState({})
  const [selectedKeys, setSelectedKeys] = useState("0");
  const loc = useLocation();
  const dispatch = useDispatch();


  const { data: projectList, loading, error } = useSelector((state => state?.rootReducer?.project || {}));

  // 1. Initialize the ref for the scrolling container
  const mainRef = useRef(null); 
  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto"
      });
    }
  }, [loc.pathname]);
  // ==========================================

  console.log("pageIsLoading", pageIsLoading)

  const handleCreateOrg = (orgName) => {
    const newOrg = {
      id: `org_${organizations.length + 1}`,
      name: orgName
    };
    setOrganizations([...organizations, newOrg]);
    setIsNewOrgModalOpen(false);
  };

  const handleOrgChange = (org) => {
    setSelectedOrg(org);
    const newOrgProjects = projectList[org.id] || [];

    // console.log("##newOrgProjects", projectList, newOrgProjects);
    setSelectedProject(newOrgProjects[0] || null);
    localStorage.setItem('selectedProject', newOrgProjects[0]?.projectId || newOrgProjects[0]?.id);
  };

  useEffect(() => {
    if(!projectList) return;
    const projectId = localStorage.getItem('selectedProject');
    const alreadySelected = (projectList ?? []).find((p) => p?.projectId === projectId || p?.name == 'TecoreLabs Compliant SOC2 and HIPAA');

    // const projectId = localStorage.getItem('selectedProject') || projectList?.[0]?.projectId || null;
    // const alreadySelected = (projectList ?? []).find((project) => project.projectId === projectId)

    
    
    setSelectedProject(alreadySelected);
    dispatch(switchProject(alreadySelected));
    // localStorage.setItem('selectedProject', projectList?.[0]?.projectId || projectList?.[0]?.id);

    setView({ type: 'dashboard', data: null });
  }, [projectList])

  const getProjectList = async () => {
    setPageIsLoading(true);
    try {
      const result = await dispatch(getProjects()).unwrap();
      if(result?.status) {
        // setProjects(result?.data ?? []);
      }
    } catch (error) {
      console.log("##error", error.message);
    } finally {
      setPageIsLoading(false);
    }
  }

  const handleCreateProject = async (newProjectData) => {

    setPageIsLoading(true);
    try {      
      const payload = {
        name: newProjectData.name,
        frameworkIds: newProjectData.frameworkIds,
        orgId: orgId,
      };

      const result = await dispatch(createProject(payload)).unwrap();
      if(result?.status) {
        getProjectList()
      }
    } catch (error) {
      console.log('##error', error);
    } finally {
      setPageIsLoading(false);
    }

    // const newProject = {
    //   name: newProjectData.name,
    //   frameworkIds: newProjectData.frameworkIds,
    //   orgId: orgId,
    // };
    // handleFetchRequest("project", `${apiUrl.create_project}`, "POST", newProject).then((response) => {
    //   if (response?.status === true) {
    //     getProjectList()
    //     setIsNewProjectModalOpen(false)
    //   } else {
    //     setPageIsLoading(false);
    //     console.log("error", response);
    //   }
    // });
  };

  useEffect(() => {
    getProjectList()
  }, [])
  useEffect(() => {
    if (activeNav === 'ai_buddy') {
      setIsSidebarOpen(false)
    } else {
      setIsSidebarOpen(true)
    }
  }, [activeNav])


  useEffect(() => {
    switch (loc.pathname.split("/")[1]) {
      case "ai-buddy":
        setActiveNav("ai_buddy");
        break;
      case "dashboard":
        setActiveNav("dashboard");
        break;
      case "controls":
        setActiveNav("controls");
        break;
      case "risks":
        setActiveNav("risks_page");
        break;
      case "policy":
        setActiveNav("policy");
        break;
      case "reports":
        setActiveNav("reports");
        break;
      case "team-member":
        setActiveNav("teamMember");
        break;
      case "frameworks":
        setActiveNav("frameworks");
        break;
      case "roles-permission":
        setActiveNav("roles_permission");
        break;
      case "projects":
        setActiveNav("project");
        break;
      case "team":
        setActiveNav("team");
        break;
      case "organization":
        setActiveNav("organization");
        break;
      case "settings":
        setActiveNav("settings");
        break;
      default:
        break;
    }
    // setCollapsed(false)
  }, [loc.pathname]);




  return (
    <div className="flex h-screen bg-slate-50 text-slate-900 ">
      <Sidebar
        selectedOrg={selectedOrg}
        setSelectedOrg={handleOrgChange}
        // projects={projects}
        projects={projectList}
        selectedProject={selectedProject}
        setSelectedProject={setSelectedProject}
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        onNewProjectClick={() => setIsNewProjectModalOpen(true)}
        onNewOrgClick={() => setIsNewOrgModalOpen(true)}
        organizations={organizations}
        activeNav={activeNav}
        setActiveNav={setActiveNav}
      />
      <NewOrgModal
        isOpen={isNewOrgModalOpen}
        onClose={() => setIsNewOrgModalOpen(false)}
        onCreate={handleCreateOrg}
      />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header
          users={mockUsers}
          currentUser={currentUser}
          selectedProject={selectedProject}
          activeNav={activeNav}
          setCurrentUser={setCurrentUser}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          selectedOrg={selectedOrg}
          setSelectedOrg={handleOrgChange}
          onNewOrgClick={() => setIsNewOrgModalOpen(true)}
          organizations={organizations}
        />
        {/* DYNAMIC RENDERING HAPPENS ENTIRELY INSIDE MAIN SO THE SIDEBAR/HEADER NEVER UNMOUNT */}
        <main ref={mainRef} className={`flex-1 overflow-x-hidden overflow-y-auto h-100 ${(activeNav === "ai_buddy" || activeNav === "controls" )? "overflow-y-hidden" : 'p-4 sm:p-6 lg:p-8'}`}>
          {children}
        </main>
      </div>

      <NewProjectModal
        setPageIsLoading={setPageIsLoading}
        pageIsLoading={pageIsLoading}
        isOpen={isNewProjectModalOpen}
        onClose={() => setIsNewProjectModalOpen(false)}
        onCreate={handleCreateProject}
        getProjectList={getProjectList}
        handleFetchRequest={handleFetchRequest}
        mockUsers={mockUsers}
        apiUrl={apiUrl}
      />

      {pageIsLoading && <PageLoader />}
    </div>

  );
};

export default View;



// Project Area Component 
const ProjectArea = ({ setPageIsLoading, pageIsLoading, project, currentUser, evidenceData, setEvidenceData, onPreviewFile, mockControls, onStatusChange, remarksData, onAddRemark, generatedReports, setGeneratedReports, activeNav }) => {
  // Left empty/standardized since navigation handling happens primarily in App component now.
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-3xl font-extrabold tracking-tight text-slate-900">{project?.name}</h2>
        <p className="text-slate-500 mt-1">An overview of your compliance status and outstanding tasks.</p>
      </div>
      <div className="mt-6">
        {/* Fallback space for project area contents */}
      </div>
    </div>
  );
}

// New Project Modal Component
const NewProjectModal = ({ setPageIsLoading, pageIsLoading, isOpen, onClose, onCreate, mockUsers, handleFetchRequest, apiUrl }) => {
  const fallbackFrameworks = [
    {
      "frameworkId": "5f79dd87-1e2a-490c-896f-0758abece20b",
      "name": "SOC 2",
      "description": "System and Organization Controls 2, developed by the AICPA, focusing on security, availability, processing integrity, confidentiality, and privacy."
    },
    {
      "frameworkId": "4e583e2f-8f9d-47c5-8549-beb0ee993aae",
      "name": "GDPR",
      "description": "General Data Protection Regulation for data protection and privacy in the European Union."
    },
    {
      "frameworkId": "a396b917-d2c2-4db2-b64e-8ca876fb89c2",
      "name": "HIPAA",
      "description": "Health Insurance Portability and Accountability Act, which provides data privacy and security provisions for safeguarding medical information."
    }
  ];

  // const availableLanguages = [
  //   { id: 'en', name: 'English' },
  //   { id: 'ar', name: 'Arbic' },
  //   { id: 'es', name: 'Spanish' },
  //   { id: 'fr', name: 'French' },
  //   { id: 'de', name: 'German' },
  //   { id: 'pt', name: 'Portuguese' },
  //   { id: 'zh', name: 'Chinese' }
  // ];

  const availableLanguages = [
    { id: 'English', name: 'English' },
    { id: 'Arbic', name: 'Arbic' },
    { id: 'Spanish', name: 'Spanish' },
    { id: 'French', name: 'French' },
    { id: 'German', name: 'German' },
    { id: 'Portuguese', name: 'Portuguese' },
    { id: 'Chinese', name: 'Chinese' }
  ];

  const [projectName, setProjectName] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [frameworks, setFrameworks] = useState([]);
  const [selectedFrameworks, setSelectedFrameworks] = useState([]);

  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [tempSelectedLanguages, setTempSelectedLanguages] = useState([]);

  const [selectedAuditor, setSelectedAuditor] = useState(null);
  const [selectedCoordinator, setSelectedCoordinator] = useState(null);

  const [openDropdown, setOpenDropdown] = useState(null);
  const [tempSelectedFrameworks, setTempSelectedFrameworks] = useState([]);
  const dropdownRef = useRef(null);

  const getFrameworkList = () => {
    setPageIsLoading(true);
    handleFetchRequest("framework", `${apiUrl.framework_list}`).then((response) => {
      if (response?.statusCode === 200) {
        setFrameworks(response?.data ?? fallbackFrameworks);
      } else {
        setFrameworks(fallbackFrameworks);
      }
      setPageIsLoading(false);
    });
  };

  useEffect(() => {
    if (isOpen) getFrameworkList();
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleApplyFrameworks = (e) => {
    e.preventDefault();
    setSelectedFrameworks(tempSelectedFrameworks);
    setOpenDropdown(null);
  };

  const handleApplyLanguages = (e) => {
    e.preventDefault();
    setSelectedLanguages(tempSelectedLanguages);
    setOpenDropdown(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!projectName || !dueDate || selectedFrameworks.length === 0 || selectedLanguages.length === 0 || !selectedAuditor || !selectedCoordinator) return;

    onCreate({
      name: projectName,
      dueDate: dueDate,
      frameworkIds: selectedFrameworks,
      languageIds: selectedLanguages,
      auditorId: selectedAuditor.id,
      coordinatorId: selectedCoordinator.id
    });

    setProjectName('');
    setDueDate('');
    setSelectedFrameworks([]);
    setTempSelectedFrameworks([]);
    setSelectedLanguages([]);
    setTempSelectedLanguages([]);
    setSelectedAuditor(null);
    setSelectedCoordinator(null);
    setOpenDropdown(null);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg m-4 animate-in zoom-in-95 duration-200" onClick={(e) => e.stopPropagation()}>
        <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50 rounded-t-2xl">
          <h2 className="text-xl font-black text-slate-900 tracking-tight">Create a New Project</h2>
          <button onClick={onClose} className="p-2 bg-white rounded-full hover:bg-rose-50 hover:text-rose-600 text-slate-400 shadow-sm transition-colors border border-slate-200">
            <X className="w-5 h-5 text-slate-500" />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="p-8 space-y-6 max-h-[70vh] overflow-y-auto">

            <div className="flex flex-col sm:flex-row justify-between gap-5">
              <div className="w-full">
                <label className="block text-sm font-black text-slate-700 mb-2 tracking-wide">Project Name</label>
                <input
                  type="text"
                  value={projectName}
                  onChange={(e) => setProjectName(e.target.value)}
                  className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none transition-shadow"
                  placeholder="Enter project name..."
                />
              </div>

            </div>

            <div className='flex flex-col sm:flex-row justify-between gap-5'>
              <div className="relative w-full" ref={openDropdown === 'auditor' ? dropdownRef : null}>
                <label className="block text-sm font-black text-slate-700 mb-2  tracking-wide">Primary Auditor</label>
                <div
                  onClick={() => setOpenDropdown(openDropdown === 'auditor' ? null : 'auditor')}
                  className="w-full px-4 py-2.5 border border-slate-300 rounded-lg bg-white cursor-pointer flex justify-between items-center hover:border-blue-400 transition-colors"
                >
                  <span className="text-sm font-medium text-slate-700 flex items-center truncate">
                    <ShieldCheck className="w-4 h-4 mr-2 text-blue-600" />
                    {selectedAuditor ? selectedAuditor.name : "Select Auditor"}
                  </span>
                  <ChevronDown className="w-4 h-4 text-slate-400" />
                </div>
                {openDropdown === 'auditor' && (
                  <div className="absolute z-20 mt-2 w-full bg-white border border-slate-200 rounded-xl shadow-xl py-2 max-h-48 overflow-y-auto">
                    {mockUsers?.map(user => (
                      <div
                        key={user.id}
                        onClick={() => { setSelectedAuditor(user); setOpenDropdown(null); }}
                        className="px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-blue-50 hover:text-blue-700 cursor-pointer flex justify-between items-center transition-colors"
                      >
                        {user.name}
                        {selectedAuditor?.id === user.id && <Check className="w-4 h-4 text-blue-600" />}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="relative w-full" ref={openDropdown === 'coordinator' ? dropdownRef : null}>
                <label className="block text-sm font-black text-slate-700 mb-2  tracking-wide">Coordinator</label>
                <div
                  onClick={() => setOpenDropdown(openDropdown === 'coordinator' ? null : 'coordinator')}
                  className="w-full px-4 py-2.5 border border-slate-300 rounded-lg bg-white cursor-pointer flex justify-between items-center hover:border-blue-400 transition-colors"
                >
                  <span className="text-sm font-medium text-slate-700 flex items-center truncate">
                    <Briefcase className="w-4 h-4 mr-2 text-emerald-600" />
                    {selectedCoordinator ? selectedCoordinator.name : "Select Coordinator"}
                  </span>
                  <ChevronDown className="w-4 h-4 text-slate-400" />
                </div>
                {openDropdown === 'coordinator' && (
                  <div className="absolute z-20 mt-2 w-full bg-white border border-slate-200 rounded-xl shadow-xl py-2 max-h-48 overflow-y-auto">
                    {mockUsers?.map(user => (
                      <div
                        key={user.id}
                        onClick={() => { setSelectedCoordinator(user); setOpenDropdown(null); }}
                        className="px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-blue-50 hover:text-blue-700 cursor-pointer flex justify-between items-center transition-colors"
                      >
                        {user.name}
                        {selectedCoordinator?.id === user.id && <Check className="w-4 h-4 text-blue-600" />}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className='flex flex-col sm:flex-row justify-between gap-5'>
              <div className="relative w-full" ref={openDropdown === 'framework' ? dropdownRef : null}>
                <label className="block text-sm font-black text-slate-700 mb-2 tracking-wide">Select Frameworks</label>
                <div
                  onClick={() => {
                    setOpenDropdown(openDropdown === 'framework' ? null : 'framework');
                    setTempSelectedFrameworks(selectedFrameworks);
                  }}
                  className="w-full px-4 py-2.5 border border-slate-300 rounded-lg bg-white cursor-pointer flex justify-between items-center hover:border-blue-400 transition-colors"
                >
                  <span className="text-sm font-medium text-slate-700 truncate">
                    {selectedFrameworks.length > 0 ? `${selectedFrameworks.length} Selected` : "Select..."}
                  </span>
                  <ChevronDown className="w-4 h-4 text-slate-400" />
                </div>

                {openDropdown === 'framework' && (
                  <div className="absolute z-20 mt-2 w-full bg-white border border-slate-200 rounded-xl shadow-xl overflow-hidden">
                    <div className="max-h-48 overflow-y-auto p-3 space-y-1">
                      {frameworks.map(fw => (
                        <div
                          key={fw.frameworkId}
                          onClick={() => setTempSelectedFrameworks(prev =>
                            prev.includes(fw.frameworkId) ? prev.filter(id => id !== fw.frameworkId) : [...prev, fw.frameworkId]
                          )}
                          className="flex items-center justify-between p-3 hover:bg-slate-50 rounded-lg cursor-pointer transition-colors border border-transparent hover:border-slate-200"
                        >
                          <span className="text-sm font-bold text-slate-800">{fw.name}</span>
                          <div className={`w-5 h-5 rounded flex items-center justify-center transition-colors border ${tempSelectedFrameworks.includes(fw.frameworkId) ? 'bg-blue-600 border-blue-600' : 'bg-white border-slate-300'}`}>
                            {tempSelectedFrameworks.includes(fw.frameworkId) && <Check className="w-3.5 h-3.5 text-white stroke-[3]" />}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="p-3 border-t border-slate-100 bg-slate-50 flex justify-end">
                      <button
                        type="button"
                        onClick={handleApplyFrameworks}
                        className="px-4 py-2 text-sm font-bold text-white bg-blue-600 rounded-lg shadow-sm hover:bg-blue-700"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </div>

            </div>
            <div className='flex flex-col sm:flex-row justify-between gap-5'>
              <div className="w-full">
                <label className="block text-sm font-black text-slate-700 mb-2 tracking-wide">Due Date</label>
                <input
                  type="date"
                  value={dueDate}
                  onChange={(e) => setDueDate(e.target.value)}
                  className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none transition-shadow text-slate-700 bg-white"
                />
              </div>

              <div className="relative w-full" ref={openDropdown === 'language' ? dropdownRef : null}>
                <label className="block text-sm font-black text-slate-700 mb-2 tracking-wide">Select Languages</label>
                <div
                  onClick={() => {
                    setOpenDropdown(openDropdown === 'language' ? null : 'language');
                    setTempSelectedLanguages(selectedLanguages);
                  }}
                  className="w-full px-4 py-2.5 border border-slate-300 rounded-lg bg-white cursor-pointer flex justify-between items-center hover:border-blue-400 transition-colors"
                >
                  <span className="text-sm font-medium text-slate-700 truncate">
                    {selectedLanguages.length > 0 ? `${selectedLanguages.length} Selected` : "Select..."}
                  </span>
                  <ChevronDown className="w-4 h-4 text-slate-400" />
                </div>

                {openDropdown === 'language' && (
                  <div className="absolute z-20 mt-2 w-full bg-white border border-slate-200 rounded-xl shadow-xl overflow-hidden">
                    <div className="max-h-48 overflow-y-auto p-3 space-y-1">
                      {availableLanguages.map(lang => (
                        <div
                          key={lang.id}
                          onClick={() => setTempSelectedLanguages(prev =>
                            prev.includes(lang.id) ? prev.filter(id => id !== lang.id) : [...prev, lang.id]
                          )}
                          className="flex items-center justify-between p-3 hover:bg-slate-50 rounded-lg cursor-pointer transition-colors border border-transparent hover:border-slate-200"
                        >
                          <span className="text-sm font-bold text-slate-800">{lang.name}</span>
                          <div className={`w-5 h-5 rounded flex items-center justify-center transition-colors border ${tempSelectedLanguages.includes(lang.id) ? 'bg-blue-600 border-blue-600' : 'bg-white border-slate-300'}`}>
                            {tempSelectedLanguages.includes(lang.id) && <Check className="w-3.5 h-3.5 text-white stroke-[3]" />}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="p-3 border-t border-slate-100 bg-slate-50 flex justify-end">
                      <button
                        type="button"
                        onClick={handleApplyLanguages}
                        className="px-4 py-2 text-sm font-bold text-white bg-blue-600 rounded-lg shadow-sm hover:bg-blue-700"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="p-6 bg-slate-50 border-t border-slate-100 flex justify-end space-x-3 rounded-b-2xl">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-2.5 text-sm font-bold text-slate-700 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!projectName || !dueDate || selectedFrameworks.length === 0 || selectedLanguages.length === 0 || !selectedAuditor || !selectedCoordinator}
              className="px-5 py-2.5 text-sm font-bold text-white bg-blue-600 rounded-lg shadow-sm hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all active:scale-95"
            >
              Create Project
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Request Changes Modal
const RequestChangesModal = ({ setPageIsLoading, pageIsLoading, isOpen, onClose, onSubmit }) => {
  const [remark, setRemark] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!remark) return;
    onSubmit(remark);
    setRemark('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg m-4 animate-in zoom-in-95 duration-200" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit}>
          <div className="p-6 border-b border-slate-100 bg-slate-50 rounded-t-2xl">
            <h2 className="text-xl font-extrabold text-slate-900">Request Changes</h2>
            <p className="text-sm font-medium text-slate-500 mt-1">Provide feedback for the user to address.</p>
          </div>
          <div className="p-6">
            <label className="block text-sm font-bold text-slate-700 mb-2 uppercase tracking-wider">Feedback Details</label>
            <textarea value={remark} onChange={(e) => setRemark(e.target.value)} rows="5" className="w-full px-4 py-3 border border-slate-300 rounded-xl shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm transition-shadow" placeholder="e.g., Please provide the access review logs for Q3..."></textarea>
          </div>
          <div className="p-6 bg-slate-50 border-t border-slate-100 flex justify-end space-x-3 rounded-b-2xl">
            <button type="button" onClick={onClose} className="px-5 py-2.5 text-sm font-bold text-slate-700 bg-white border border-slate-200 rounded-lg shadow-sm hover:bg-slate-50 transition-colors">Cancel</button>
            <button type="submit" className="px-5 py-2.5 text-sm font-bold text-white bg-amber-500 border border-transparent rounded-lg shadow-sm hover:bg-amber-600 transition-colors active:scale-95">Submit Feedback</button>
          </div>
        </form>
      </div>
    </div>
  );
};

// New Organization Modal
const NewOrgModal = ({ isOpen, onClose, onCreate }) => {
  const [orgName, setOrgName] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (orgName.trim()) {
      onCreate(orgName);
      setOrgName('');
    }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md animate-in zoom-in-95 duration-200">
        <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50 rounded-t-2xl">
          <h2 className="text-xl font-extrabold text-slate-900">Create Workspace</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-white border border-transparent hover:border-slate-200 transition-colors"><X className="w-5 h-5 text-slate-500" /></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="p-8">
            <label className="block text-sm font-bold text-slate-700 mb-2 uppercase tracking-wider">Organization Name</label>
            <input
              autoFocus
              type="text"
              value={orgName}
              onChange={(e) => setOrgName(e.target.value)}
              className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none shadow-sm transition-shadow text-sm"
              placeholder="e.g. Acme Corp"
            />
          </div>
          <div className="p-6 bg-slate-50 border-t border-slate-100 flex justify-end space-x-3 rounded-b-2xl">
            <button type="button" onClick={onClose} className="px-5 py-2.5 text-sm font-bold text-slate-700 bg-white border border-slate-300 rounded-lg shadow-sm hover:bg-slate-50 transition-colors">Cancel</button>
            <button type="submit" className="px-5 py-2.5 text-sm font-bold text-white bg-blue-600 rounded-lg shadow-sm hover:bg-blue-700 transition-colors active:scale-95">Add Workspace</button>
          </div>
        </form>
      </div>
    </div>
  );
};
